import React from 'react'
import { string, bool } from 'prop-types'

import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import triggerEvent from 'utils/dataLayer'

import Button from 'components/atoms/Button'
import AuthenticatedLink from 'components/molecules/AuthenticatedLink'

const openNewTab = {
  target: '_blank',
  rel: 'noopener nofollow',
}

const ScholarshipBrochureButton = ({
  slug,
  url,
  isTracking,
  forSticky,
}) => (
  <>
    {
      isTracking ?
        <AuthenticatedLink
          href={`/scholarships/${slug}/brochure`}
          className={`scholarship-brochure-btn btn btn-campus ${forSticky ? 'scholarship-brochure-btn--for-sticky' : ''}`}
          onClick={() => { triggerEvent('ga/campusprofile/register') }}
          linkProps={openNewTab}
        >
          {intl.get('school.download_brochure')}
        </AuthenticatedLink> :
        <Button
          className={`scholarship-brochure-btn btn btn-white ${forSticky ? 'scholarship-brochure-btn--for-sticky' : ''}`}
          component="a"
          href={url}
          linkProps={openNewTab}
          onClick={() => { triggerEvent('ga/campusprofile/register') }}
        >
          {intl.get('school.download_brochure')}
        </Button>
    }
    <style jsx global>
      {`
        .scholarship-brochure-btn {
          font-size: 14px;
          font-weight: bold;
          padding: 14px 28px;
          border: none;
          margin: 8px 0;
          width: 100%;
          background-color: #fff;
          color: #0fc3c4;
          &:hover {
            background-color: #f6f7fa;
            color: #0fc3c4;
          }
          @media screen and (min-width: 768px) {
            width: unset;
            margin: 8px;
          }
          &--for-sticky {
            border-radius: 4px;
            box-shadow: 0 2px 4px 0 rgba(107, 143, 188, 0.55);
            color: #485c77;
            &:hover {
              color: #485c77;
            }
            @media screen and (max-width: 767px) {
              border-radius: 20px;
              box-shadow: 0 2px 8px 0 rgba(107, 143, 188, 0.85);
              padding: 12px 28px;
              margin: 0;
              width: unset;
            }
          }
        }
      `}
    </style>
  </>
)

ScholarshipBrochureButton.propTypes = {
  slug: string.isRequired,
  url: string.isRequired,
  isTracking: bool,
  forSticky: bool,
}

ScholarshipBrochureButton.defaultProps = {
  isTracking: false,
  forSticky: false,
}

export { ScholarshipBrochureButton }
export default branch({
  slug: ['serverProps', 'scholarship', 'slug'],
  url: ['serverProps', 'scholarship', 'brochure'],
  isTracking: ['serverProps', 'scholarship', 'record_brochure_leads'],
}, ScholarshipBrochureButton)
